import React, { Fragment, useState, useEffect, useContext } from 'react'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import Stats from './../Stats'
import { selectUnit } from '@formatjs/intl-utils'
import NiceModal from '@ebay/nice-modal-react'
import CreateTaskDropdown from './../CreateTaskDropdown'
import { Button, Chip, Card } from '@arnsbogroup/react-voicearchive'
import { Menu, Transition } from '@headlessui/react'
import DeleteTaskMenuItem from '../DeleteTaskMenuItem'

const VersionPage = ({ version, order, refetch, readOnly }) => {
  const [fact, setFact] = useState(null)
  const { formatMessage, formatRelativeTime } = useIntl()

  const stats = [
    { title: 'Tasks', primary: version.tasks.length, secondary: null, stat: null, changeType: '+' },
    { title: 'Last change', primary: formatRelativeTime(...Object.values((selectUnit(+version.crdate * 1000)))), secondary: null, stat: null, changeType: '+' },
    { title: 'Created', primary: formatRelativeTime(...Object.values(selectUnit(+version.tstamp * 1000))), secondary: null, stat: null, changeType: '+' },
    { title: 'Who is awesome?', primary: 'You.', secondary: null, stat: null, changeType: '+' },
  ]

  useEffect(() => {
    fetch('https://uselessfacts.jsph.pl/api/v2/facts/random')
      .then(response => response.json())
      .then(({ text }) => setFact(text))
  }, [])

  return (
    <div>
      <div className="p-4 flex items-center justify-between border-b border-gray-200">
        <div className="space-y-2">
          <Chip>Version</Chip>
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            { version.title || 'Untitled' }
          </h2>
        </div>

        <div className="mt-5 flex lg:mt-0 lg:ml-4 shrink-0">
          <CreateTaskDropdown
            refetch={refetch}
            order={order}
            version={version}
            buttonProps={{
              size: 'sm',
              disabled: readOnly,
              className: '',
              variant: 'solid',
            }}

          />
          <Menu as="div" className="relative ml-3">
            <Menu.Button>
              <Button variant="outline" size="sm" icon={['fal', 'ellipsis-vertical']} iconPosition="right">
                More
              </Button>
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-50 mt-2 -mr-1 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <DeleteTaskMenuItem taskType="Version" readOnly={readOnly} task={version} order={order} refetch={refetch} />
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

      </div>

      <Stats stats={stats} />

      { fact &&
        <div className="flex items-center justify-center py-40">
          <Card className="w-80 p-4 space-y-4">
            <Chip>Did you know?</Chip>
            <p className="text-gray-400 text-sm">{ fact }</p>
          </Card>
        </div>
      }
    </div>
  )
}

export default VersionPage
